export default __webpack_public_path__ + "static/0276-340a743daee8d42c9c219f30ecca0e0b.png";